import styled from "styled-components";

const AdminFaqSc = styled.div`
  margin: 10px;
  padding: 5px;
  height: 90vh;
  border-radius: 10px;
  /* fallback for old browsers */
  width: 100vw;
  /* Chrome 10-25, Safari 5.1-6 */
  position: absolute;
  top: 45px;
  .query-conatiner {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .emp-profile {
    width: 100px;
  }
  .emp-id {
    width: 100px;
  }
  .query-date {
    width: 50px;
  }
  .query-time {
    width: 60px;
  }
  .content-tabs {
    align-content: center;
  }
  .query-conatiner-list {
    width: 100vw;
    display: flex;

    justify-content: center;
    align-items: center;
    padding: 1rem;
  }
  .emp-details {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 20px;
    border: #212529 1px;
    background-color: #edecec;
    padding: 3px;
  }
  .emp-image-name {
    display: flex;
  }
  .emp-image-name-list {
    display: flex;
    width: 190px;
    gap: 5px;
    align-items: center;
  }
  .emp-id-list {
    width: 100px;
  }
  .query-date-list {
    width: 100px;
  }
  .query-time-list {
    width: 60px;
  }

  .faq-approval-list {
    display: flex;
    justify-content: space-between;
    width: 300px;
  }
  .emp-details-faq {
    display: flex;
    flex-direction: column;
  }
  .query-details {
    background-color: #edecec;
    width: 500px;
    height: 300px;
  }
  .emp-image-class {
    width: 80px;
  }
  .faq-approval-container {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
  .employee-faq-details {
    display: flex;
    flex-direction: column;
  }
  .faq-approval-page-container {
    display: flex;
    flex-direction: row;
    gap: 25px;
  }
  .query-content {
    background-color: #edecec;
    width: 800px;
    height: 300px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }
  .input {
    width: 200px;
  }
  .query-content-data {
    padding: 20px;
  }
  .employee-faq-id-details {
    font-weight: bolder;
  }
  .form-select {
    display: block;
    width: 30%;
    padding: 0.375rem 2.25rem 0.375rem 0.75rem;
    -moz-padding-start: calc(0.75rem - 3px);
    font-size: 1rem;
    font-weight: 400;
    line-height: 1.5;
    color: #212529;
    background-color: #fff;
    background-repeat: no-repeat;
    background-position: right 0.75rem center;
    background-size: 16px 12px;
    border: 1px solid #ced4da;
    border-radius: 0.375rem;
    transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
    appearance: none;
  }
  .input-class-button {
    width: 30%;
    height: 100%;
    border: 1px solid #ced4da;
    border-radius: 0.375rem;
  }
  .input-class-buttons {
    width: 30%;
    height: 36px;
    border: 1px solid #ced4da;
    border-radius: 0.375rem;
    padding: 5px;
  }
  .approval-sub {
    display: flex;
    justify-content: flex-end;
    align-items: flex-end;
    gap: 5px;
    padding: 10px;
  }
  .response {
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .response-button {
    display: flex;
    justify-content: center;
    align-content: center;
  }
  .content > .response-button {
    justify-content: center;
  }

  .anonymous-main-list {
    display: flex;
    justify-content: space-around;
    margin: 4px;
  }
  .anonymous-title {
    display: flex;
    flex-direction: row;
    justify-content: space-around;
    align-items: center;
    margin: 2px;
    background-color: #edecec;
    height: 80px;
  }
  .anonymous-container {
    width: 90vw;
    padding: 10px;
    display: flex;
    /* flex-direction: column; */
    /* justify-content: space-between; */
    border-radius: 3px;
    /* overflow-y: visible; */
  }
  .active-anonymous {
    display: flex;
    width: 100vw;
  }
  .posted-heading {
    display: flex;
    justify-content: space-between;
    font-weight: bold;
    padding: 10px;
  }
  .anonymous-rep {
    display: flex;
    position: relative;
  }
  .anonymous-posted-page {
    background-color: #edecec;
    width: 650px;
    height: 400px;
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    padding: 10px;
    border-radius: 3px;
    border-style: solid;
  }
  .anonymous-main-container {
    width: 100vw;
    height: 100vh;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .anonymous-container::-webkit-scrollbar {
    display: none;
  }
  .form-group {
    font-size: medium;
    font-weight: bold;
  }
  table {
    font-family: arial, sans-serif;
    width: 90vw;
    margin: 30px auto;
    max-width: 90vw;
    background-color: #fff;
    box-shadow: 0 0 20px rgba(0, 0, 0, 0.1);
    border-collapse: collapse;
  }

  th {
    background-color: #4285f4;
    color: #fff;
    border: 1px solid #4285f4;
    text-align: center;
    padding: 12px;
  }

  .heading {
    text-align: center;
  }

  td {
    border: 1px solid #ddd;
    padding: 8px;
    text-align: center;
  }

  tr:nth-child(even) {
    background-color: #f2f2f2;
  }

  th:hover {
    background-color: #3367d6;
  }

  tr:hover td {
    background-color: #e4f0fb;
  }
`;

export default AdminFaqSc;
